<template>
  <div>
    <div v-for="(dc, index) of chartData" :key="index" class="mt-4">
      <div class="text-base text-blue-600 my-2 font-bold">
        UPS STATUS: {{ dc.label }}
      </div>
      <div class="flex">
        <div
          v-for="(ups, upsIndex) of dc.ups"
          :key="upsIndex"
          class="w-1/2 flex justify-between"
          :class="upsIndex % 2 === 0 ? 'ml-4' : 'mr-4'"
        >
          <div class="w-full">
            <!-- <div class="flex justify-between w-full">
              <div
                v-for="(item, valIndex) of [
                  'load',
                  'input',
                  'bypass',
                  'battery'
                ]"
                :key="valIndex"
                class="px-1"
                style="width: 4.6rem;"
              >
                <div class="border rounded pt-1 text-center hover:bg-gray-100">
                  <div class="flex justify-center">
                    <img
                      :src="getImgUrl(`images/icon-${item}.png`)"
                      class="h-4"
                    />
                  </div>
                  <span
                    class="text-center uppercase"
                    style="font-size: 10px;"
                    >{{ item }}</span
                  >
                </div>
              </div>
            </div> -->
            <div class="flex justify-center pt-2">
              <SVGImage :data="chartData[index].ups[upsIndex]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SVGImage from './SVGImage'
import { randomInteger, getImgUrl } from '@/components/utils'

export default {
  components: {
    SVGImage
  },
  data() {
    return {
      chartData: [
        {
          label: 'THMO SERVER ROOM',
          ups: [
            {
              load: 0,
              loadPercentage: '-',
              input: 0,
              output: 0,
              bypass: 0,
              battery: 0,
              batteryPercentage: 0
            }
          ]
        }
      ],
      slideOptions: {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        autoplay: true,
        interval: 3000,
        pagination: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    getImgUrl,
    async fetchData() {
      const fetchUtil = this.fetchScreenData('UPSUTILCURRENT')
      const fetchBattR = this.fetchScreenData('UPSBATTCURRENT')
      const fetchUPSInVolt = this.fetchScreenData('UPSInVolt')
      const fetchUPSOutVolt = this.fetchScreenData('UPSOutVolt')

      const results = await Promise.allSettled([
        fetchUtil,
        fetchBattR,
        fetchUPSInVolt,
        fetchUPSOutVolt
      ])

      this.setUtilData(results[0].value.data)
      this.setBattRData(results[1].value.data)
      this.setInputData(results[2].value.data)
      this.setOutputData(results[3].value.data)
    },
    async fetchScreenData(screen) {
      return await this.$axios.get(
        `Dashboard/GetDashboardScreenData?screen=${screen}`
      )
    },
    setUtilData(data) {
      let picmoSensors = []

      const getPICMOValue = (sensors) => {
        const averageVals = sensors.map((x) => x.AverageVal)
        const value = averageVals.reduce((a, b) => a + b, 0)
        return Math.round(value)
      }

      data[0].ListOfSensor.forEach((item) => {
        if (item.SubDeviceName === 'THMO UPS') picmoSensors.push(item)
      })

      // set chartData
      this.chartData[0].ups[0].load = getPICMOValue(picmoSensors)
    },
    setBattRData(data) {
      let picmoSensors = []

      const getPICMOValue = (sensors) => {
        const averageVals = sensors.map((x) => x.AverageVal)
        const value = averageVals.reduce((a, b) => a + b, 0)
        return Math.round(value)
      }

      data[0].ListOfSensor.forEach((item) => {
        if (item.SubDeviceName === 'THMO UPS') picmoSensors.push(item)
      })

      // set chartData
      this.chartData[0].ups[0].battery = getPICMOValue(picmoSensors)
    },
    setInputData(data) {
      let picmoSensors = []

      const getPICMOValue = (sensors) => {
        const averageVals = sensors.map((x) => x.AverageVal)
        const value = averageVals.reduce((a, b) => a + b, 0)
        return Math.round(value)
      }

      data[0].ListOfSensor.forEach((item) => {
        if (item.SubDeviceName === 'THMO UPS') picmoSensors.push(item)
      })

      // set chartData
      this.chartData[0].ups[0].input = getPICMOValue(picmoSensors)
    },
    setOutputData(data) {
      let picmoSensors = []

      const getPICMOValue = (sensors) => {
        const averageVals = sensors.map((x) => x.AverageVal)
        const value = averageVals.reduce((a, b) => a + b, 0)
        return Math.round(value)
      }

      data[0].ListOfSensor.forEach((item) => {
        if (item.SubDeviceName === 'THMO UPS') picmoSensors.push(item)
      })

      // set chartData
      this.chartData[0].ups[0].output = getPICMOValue(picmoSensors)
    }
  }
}
</script>
